import { render, staticRenderFns } from "./TechnicalWorksModule.vue?vue&type=template&id=72377cde&scoped=true"
import script from "./TechnicalWorksModule.vue?vue&type=script&lang=js"
export * from "./TechnicalWorksModule.vue?vue&type=script&lang=js"
import style0 from "./TechnicalWorksModule.vue?vue&type=style&index=0&id=72377cde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72377cde",
  null
  
)

export default component.exports